// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AoPW","left":"styles_left__3STXw","desktopActions":"styles_desktopActions__3nJX8","title":"styles_title__3h6B4"};